module.exports = __webpack_public_path__ + "img/factsheet_parking.dab5eede.svg";